<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      :scrim="false"
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          color="primary"
          dark
          v-bind="props"
          @click="show_fullscreen()"
        >
          Full Screen
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div id="contain-graph">
          <bar-chart :chart-data="datacollection" :options="chartOptions" :height="graph_height" v-if="show_graph" class="mt-3"></bar-chart>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BarChart from "./BarChart.js";

const colorPack = [
  "#0267C1",
  "#EFA00B",
  "#591F0A",
  "#C4D7F2",
  "#91A8A4",
  "#776871"
];

export default {
  components: {
    BarChart
  },
  props: {
    compData: Array,
    max: Number
  },
  data() {
    return {
      graph_height: window.innerHeight - 80,
      dialog: false,
      show_graph: false,
      datacollection: {},
      chartOptions: {
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem) {
              return tooltipItem.yLabel;
            }
          }
        },

        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              barPercentage: 0.3
            }
          ]
        }
      }
    }
  },
  methods: {
    async show_fullscreen() {
      this.dialog = true;
      
      let val = this._props.compData;
      let labels = [];
      let data = [];
      let bgcolor = [];
      let bordercolor = [];
      val.slice(0,this._props.max).forEach((item, index) => {
        labels.push(item.company !== "zzz" ? item.company : "Other");
        data.push(item.times);
        bgcolor.push(hexToRgbA(colorPack[index % 6]));
        bordercolor.push(colorPack[index % 6]);
      });
      this.datacollection = {
        labels: labels,
        datasets: [
          {
            label: "",
            backgroundColor: bgcolor,
            borderColor: bordercolor,
            borderWidth: 1,
            data: data
          }
        ]
      };

      await this.$nextTick();
      this.show_graph = true;
    },
  }
};

function hexToRgbA(hex) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",0.7)"
    );
  }
  throw new Error("Bad Hex");
}

</script>
